
import { Footer1 } from "components/footer";
import Seo from "components/Seo";
import BackToTop from "components/BackToTop";
import { usePageTracking } from "helpers/usePageTracking";

import PrivacPolicy from "crm/other/Privacy Policy";

export default function Privacy() {
    const seo = usePageTracking("privacy");
    return (
        <>
            {seo && (
                <Seo
                    pageName="privacy"
                    title='Privacy Policy | Sales Trackify'
                    description="Read the Privacy Policy of Sales Trackify to understand how we collect, use, and protect your data."
                    keywords="privacy policy, sales trackify privacy, data protection CRM"
                    url="https://www.salestrackify.com/privacy"
                    image="/seo/trackify-preview.png"
                />
            )}
            <PrivacPolicy />
            <Footer1 />
            {/* <BackToTop /> */}
        </>
    );
}
